export const dynamicAWSConfig = (config) => {
  const parsedConfig = JSON.parse(JSON.stringify(config)).default;

  return {
    Auth: {
      region: parsedConfig.REGION,
      userPoolId: parsedConfig.USER_POOL_ID,
      userPoolWebClientId: parsedConfig.USER_POOL_CLIENT_ID,
      authenticationFlowType: 'USER_PASSWORD_AUTH',
      // cookieStorage: {
      //   domain:
      //     process.env.NODE_ENV === 'production'
      //       ? parsedConfig.CLOUDFRONT_DOMAIN_NAME
      //       : 'localhost',
      //   path: '/',
      //   expires: 1,
      //   secure:
      //     parsedConfig.CLOUDFRONT_DOMAIN_NAME === 'localhost' ? false : true,
      // },
    },
  };
};
